import React, { useEffect, useState } from "react";
import { Logo } from "@/components/Logo";

export const BusyLogo = () => {
  const [state, setState] = useState({ count: 0, label: "" });
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const on = (e) => setState(typeof e.detail === "number" ? { count: e.detail, label: "" } : e.detail);
    window.addEventListener("api-busy", on);
    return () => { window.removeEventListener("api-busy", on); };
  }, []);
  useEffect(() => {
    if (!state.count) { setVisible(false); return undefined; }
    const t = setTimeout(() => setVisible(true), 350);
    return () => { clearTimeout(t); };
  }, [state.count]);
  if (!visible) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center pointer-events-none" role="status" aria-live="polite" data-testid="busy-logo">
      <div className="flex flex-col items-center gap-3 rounded-2xl border border-border bg-card/95 backdrop-blur-md px-8 py-6 shadow-2xl animate-in fade-in zoom-in-95">
        <Logo size={40} showText={false} animated />
        <p className="text-sm font-medium text-center" data-testid="busy-logo-label">{state.label || "Sto lavorando"}…</p>
        <p className="text-xs text-muted-foreground">Attendi qualche istante, non chiudere la pagina</p>
      </div>
    </div>
  );
};
